import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import { createRoot } from 'react-dom/client';

const root = document.getElementById('root');
createRoot(root).render(<App />);


